import { OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DisplayConditionType } from '../../shared/domain/display.condition.type';
import { ItemService } from './item/item.service';
var DisplayConditionListComponent = /** @class */ (function () {
    function DisplayConditionListComponent(formBuilder, itemService) {
        this.formBuilder = formBuilder;
        this.itemService = itemService;
    }
    DisplayConditionListComponent.prototype.ngOnInit = function () {
        this.createDisplayConditionsForm();
        if (!this.getDisplayConditionsFormArray.length) {
            this.createNewDisplayCondition();
        }
    };
    Object.defineProperty(DisplayConditionListComponent.prototype, "leadGenerationConfig", {
        get: function () {
            return this.configuration;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DisplayConditionListComponent.prototype, "getDisplayConditionsFormArray", {
        get: function () {
            return this.displayConditionsFormWrapper.form.get('displayConditions');
        },
        enumerable: true,
        configurable: true
    });
    DisplayConditionListComponent.prototype.changeDisplayConditionEnabling = function (event) {
        this.leadGenerationConfig.displayConditionsEnabled = event;
    };
    DisplayConditionListComponent.prototype.createDisplayConditionsForm = function () {
        var _this = this;
        var displayConditionsToForm = this.leadGenerationConfig.displayConditions.map(function (item) {
            return _this.prepareDisplayCondition(item);
        });
        this.displayConditionsFormWrapper.form = this.formBuilder.group({
            displayConditions: this.formBuilder.array(displayConditionsToForm),
            displayConditionsLogicalOperator: this.leadGenerationConfig.displayConditionsLogicalOperator
        });
    };
    DisplayConditionListComponent.prototype.prepareDisplayCondition = function (displayConditions) {
        return this.itemService.createForm(displayConditions);
    };
    DisplayConditionListComponent.prototype.createNewDisplayCondition = function () {
        this.createDisplayCondition(this.prepareDisplayCondition({ type: DisplayConditionType.CURRENT_PAGE }));
    };
    DisplayConditionListComponent.prototype.createDisplayCondition = function (formGroup) {
        this.getDisplayConditionsFormArray.push(formGroup);
    };
    Object.defineProperty(DisplayConditionListComponent.prototype, "showRemovalIcon", {
        get: function () {
            return this.getDisplayConditionsFormArray.length > 1;
        },
        enumerable: true,
        configurable: true
    });
    DisplayConditionListComponent.prototype.deleteDisplayCondition = function (index) {
        this.getDisplayConditionsFormArray.removeAt(index);
    };
    return DisplayConditionListComponent;
}());
export { DisplayConditionListComponent };
